module.exports = __webpack_public_path__ + "marinahome.jpg?4c7a3d82d74468dda88b4bac4bdf69e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/marinahome.jpg
// module id = 134
// module chunks = 0